export default "__VITE_ASSET__B$_vfs7w__"